import { render, staticRenderFns } from "./ReportsContainer.vue?vue&type=template&id=0108fc7a&"
import script from "./ReportsContainer.vue?vue&type=script&lang=js&"
export * from "./ReportsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports